import React from "react";
import _ from "lodash";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUserDetails } from "./common/routines/user-operations";
import { useResourcePermissions } from "./common/hooks/resource-permissions";
import { routes } from "./constants/routes";

interface ProtectedAdminRouteProps {
  children: React.ReactElement;
  moduleName: string;
  fallbackPath?: string;
}

const ProtectedAdminRoute = ({
  children,
  moduleName,
  fallbackPath = "/unauthorized",
}: ProtectedAdminRouteProps) => {
  const { hasAnyPermission } = useResourcePermissions();

  const location = useLocation();
  const details = getCurrentUserDetails('superAdmin');
  const isAuthenticated =
    !_.isEmpty(details) &&
    details.accessToken &&
    (!details.expiryTime || details.expiryTime > Date.now());


  if (!isAuthenticated) {
    return <Navigate to={routes.ADMIN_LOGIN} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedAdminRoute;

